import type { GetOffersParams } from 'service/offer/resource';
import type { SearchUnpackedOffersParams } from 'service/unpacked/resource';
import pick from 'lodash/pick';

export function remoteFilterToUnpackedOffersFilter(
	filter: GetOffersParams | SearchUnpackedOffersParams,
): SearchUnpackedOffersParams {
	if (filter.category_id !== undefined && filter.category_id == '0') {
		delete filter.category_id;
	}
	const pickedFilter = pick(filter, [
		'category_id',
		'price_to',
		'price_from',
		'limit',
		'offset',
		'phrase',
		'sort',
		'shop_id',
	]);
	if (pickedFilter.sort === 'price') {
		(pickedFilter.sort as string) = 'priceAsc';
	} else if (pickedFilter.sort === '-price') {
		(pickedFilter.sort as string) = 'priceDesc';
	} else {
		delete pickedFilter.sort;
	}

	return pickedFilter as SearchUnpackedOffersParams;
}
